var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPersonDialog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11372_61740)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.25 2H21.75C22.5776 2 23.25 2.67237 23.25 3.5V8C23.25 8.82763 22.5776 9.5 21.75 9.5H19.9328L18.6343 11.75L17.335 11L19.0672 8H21.75V3.5H14.25V8H16.5V9.5H14.25C13.4224 9.5 12.75 8.82763 12.75 8V3.5C12.75 2.67237 13.4224 2 14.25 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 22.25H9.75V18.5C9.74865 17.2579 8.74207 16.2514 7.5 16.25H4.5C3.25793 16.2514 2.25135 17.2579 2.25 18.5V22.25H0.75V18.5C0.752475 16.4299 2.42992 14.7525 4.5 14.75H7.5C9.57008 14.7525 11.2475 16.4299 11.25 18.5V22.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 7.25C7.24267 7.25 8.25 8.25733 8.25 9.5C8.25 10.7427 7.24267 11.75 6 11.75C4.75733 11.75 3.75 10.7427 3.75 9.5C3.75143 8.25793 4.75793 7.25142 6 7.25ZM6 5.75C3.92895 5.75 2.25 7.42895 2.25 9.5C2.25 11.571 3.92895 13.25 6 13.25C8.07105 13.25 9.75 11.571 9.75 9.5C9.75 7.42895 8.07105 5.75 6 5.75Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11372_61740"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPersonDialog);
export default __webpack_public_path__ + "static/media/ic-person-dialog.acea4b83a29b6ebab797139d0fc7e8e6.svg";
export { ForwardRef as ReactComponent };